import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../i18n';
import shortText from '../../legacy/js/lib/short-text';
import SocialAvatar from '../../legacy/js/components/social-avatar';

const MAX_USERNAME_LENGTH = 20;

const SocialAccountChip = ({socialAccount, size = 'sm'}) => {
  const {url, username, audience = 0} = socialAccount;
  const shortName = shortText(username, MAX_USERNAME_LENGTH);

  const name = url ? <a href={url} target='_blank'>{shortName}</a> : <span>{shortName}</span>;
  const followersLabel = i18n.get('SOCIAL_ACCOUNT_CHIP_FOLLOWERS_LABEL');

  return (
    <div className='flex vf-avatar-advertiser'>
      <SocialAvatar
        size={size}
        socialAccount={socialAccount}
      >
        <div className='flex-column start-xs margin-left-1x'>
          <div>
            {name}
            <div className='margin-top-Hx'>{`${audience.toLocaleString()} ${followersLabel}`}</div>
          </div>
        </div>
      </SocialAvatar>
    </div>
  );
};

SocialAccountChip.propTypes = {
  socialAccount: PropTypes.object.isRequired,
  size: PropTypes.string
};

export default SocialAccountChip;
